import { formatDistanceToNowStrict } from 'date-fns';
import { formatDateTime } from './utils';

/** "3 hours ago" or the fallback when the value is missing/invalid. */
export function relativeTime(value: string | null | undefined, fallback = '—'): string {
  if (!value) return fallback;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return fallback;
  return `${formatDistanceToNowStrict(d)} ago`;
}

/** Absolute timestamp for tooltips; undefined when missing so `title` is omitted. */
export function absoluteTime(value: string | null | undefined): string | undefined {
  if (!value) return undefined;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? undefined : formatDateTime(d);
}

/** SNAKE_CASE stage key -> "Snake Case" unless a label override exists. */
export function prettyStage(stage: string, labels?: Record<string, string>): string {
  if (labels?.[stage]) return labels[stage];
  return stage
    .toLowerCase()
    .split('_')
    .map((w) => (w ? w[0].toUpperCase() + w.slice(1) : w))
    .join(' ');
}
